import { Component, OnInit } from '@angular/core';

import {
  FormGroup,
  FormControl,
  FormArray,
  Validators,
  Form
} from '@angular/forms';
import { IOption } from 'src/app/interfaces/option';
import { StoreService } from 'src/app/services/store.service';

import Swal from 'sweetalert2/dist/sweetalert2.js';
import { AppFormat } from '../../appFormat';

@Component({
  selector: 'app-drive-thru',
  templateUrl: './drive-thru.component.html',
  styleUrls: ['./drive-thru.component.scss'],
  host: { 'class': 'wrapper-settings' }
})
export class DriveThruComponent implements OnInit {

  public loading: boolean = false

  public changed: boolean
  public settingsFrm: FormGroup

  public status: FormControl

  public select_drivethru_type: FormControl
  public taxa_entrega_local: FormControl
  public ck_free: FormControl
  public entrega_local_gratis: FormControl

  public ck_drivethru: FormControl
  public intervalo_entrega_drivethru: FormControl
  public tempo_liberacao_drivethru: FormControl
  public num_entrega_drivethru: FormControl

  public holidays: FormArray
  public scheduling: FormArray

  public dias_semana: IOption[] = []
  public formas_entrega: IOption[] = []
  public startDate = new Date()

  constructor(private storeService: StoreService) { }

  ngOnInit(): void {
    this.changed = false

    this.formas_entrega.push({text: 'Todos', value: 'T'})
    this.formas_entrega.push({text: 'Delivery', value: 'E'})
    this.formas_entrega.push({text: 'Drive-thru', value: 'R'})

    this.dias_semana.push({text: 'Domingo', value: '1'})
    this.dias_semana.push({text: 'Segunda-feira', value: '2'})
    this.dias_semana.push({text: 'Terça-feira', value: '3'})
    this.dias_semana.push({text: 'Quarta-feira', value: '4'})
    this.dias_semana.push({text: 'Quinta-feira', value: '5'})
    this.dias_semana.push({text: 'Sexta-feira', value: '6'})
    this.dias_semana.push({text: 'Sábado', value: '7'})


    this.createFormControls()
    this.createForm()

    this.getDeliveryCondig()
  }

  createFormControls() {
    this.status = new FormControl(false)

    this.select_drivethru_type = new FormControl(null)
    this.taxa_entrega_local = new FormControl(null)
    this.ck_free = new FormControl(true)
    this.entrega_local_gratis = new FormControl(null)

    this.ck_drivethru = new FormControl(false)
    this.intervalo_entrega_drivethru = new FormControl(30)
    this.tempo_liberacao_drivethru = new FormControl(30)
    this.num_entrega_drivethru = new FormControl(5)

    this.holidays = new FormArray([])
    this.scheduling = new FormArray([])
  }

  createForm() {
    this.settingsFrm = new FormGroup({
      status: this.status,
      select_drivethru_type: this.select_drivethru_type,
      taxa_entrega_local: this.taxa_entrega_local,
      ck_free: this.ck_free,
      entrega_local_gratis: this.entrega_local_gratis,
      ck_drivethru: this.ck_drivethru,
      intervalo_entrega_drivethru: this.intervalo_entrega_drivethru,
      tempo_liberacao_drivethru: this.tempo_liberacao_drivethru,
      num_entrega_drivethru: this.num_entrega_drivethru,
      holidays: this.holidays,
      scheduling: this.scheduling
    })
  }

  getDeliveryCondig() {
    this.loading = true
    this.storeService.getDriveThru().subscribe(res => {
      this.resDriveThru(res)
      this.loading = false
    })
  }

  resDriveThru(res) {
    if (res['success'] == true) {

      let drivethru = res['drivethru'];

      if (drivethru) {
        this.status.setValue(drivethru['entrega_local'] == 'S')
        this.taxa_entrega_local.setValue(drivethru['taxa_entrega_local'])
        this.entrega_local_gratis.setValue(drivethru['entrega_local_gratis'])

        this.select_drivethru_type.setValue(drivethru['taxa_entrega_local'] == null ? "1" : "2")
        this.ck_free.setValue(drivethru['entrega_local_gratis'] == null ? false : true)
      }

      let holidays = res['holidays']
      if (holidays && holidays.length > 0) {
        this.holidays.clear()
        for(let i in holidays) {

          let dia = holidays[i]['dia'].split(' ')
          dia = AppFormat.dateYMDUTCMoment(dia[0])

          this.onAddNewHoliday({
            dia: dia,
            tipo: holidays[i]['tipo']
          })
        }
      }

      /**
       *
       *
       * agendamento
       *
       */
       let agendamento = res['agendamento']

       if (agendamento) {
         this.ck_drivethru.setValue(agendamento['drivethru'] == 'S')

         this.intervalo_entrega_drivethru.setValue(agendamento['intervalo_entrega_drivethru'])

         this.tempo_liberacao_drivethru.setValue(agendamento['tempo_liberacao_drivethru'])
         this.num_entrega_drivethru.setValue(agendamento['num_entrega_drivethru'])

         if (agendamento['scheduling'] && agendamento['scheduling'].length > 0) {
           this.scheduling.clear()
           for(let i in agendamento['scheduling']) {
             this.onAddNewRangeHour({
               diasemana: parseInt(agendamento['scheduling'][i]['diasemana']).toString(),
               hora_inicio: agendamento['scheduling'][i]['hora_inicio'],
               hora_fim: agendamento['scheduling'][i]['hora_fim']
             })
           }
         }
       }

    }
  }

  onAddNewHoliday(obj) {
    this.holidays.push(new FormGroup({
      dia: new FormControl(obj != undefined && obj.dia ? obj.dia : null),
      tipo: new FormControl(obj != undefined && obj.tipo ? obj.tipo : null)
    }))
  }

  onRemoveHoliday(i) {
    Swal.fire({
      title: 'Você deseja remover esta data?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        let fGroup = <FormGroup>this.holidays.controls[i]
        let tipo = <FormControl>fGroup.controls.tipo

        tipo.setValue(-1)

        this.onChangeDetail()
      }
    })
  }

  onAddNewRangeHour(obj) {
    this.scheduling.push(new FormGroup({
      diasemana: new FormControl(obj != undefined && obj.diasemana ? obj.diasemana : null),
      hora_inicio: new FormControl(obj != undefined && obj.hora_inicio ? obj.hora_inicio : null),
      hora_fim: new FormControl(obj != undefined && obj.hora_fim ? obj.hora_fim : null)
    }))
  }

  onRemoveRangeHour(i) {
    Swal.fire({
      title: 'Você deseja remover este horário?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!',
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        let fGroup = <FormGroup>this.scheduling.controls[i]
        let diasemana = <FormControl>fGroup.controls.diasemana

        diasemana.setValue(-1)

        this.onChangeDetail()
      }
    })
  }


  onChangeDetail() {
    this.changed = true
  }

  onCancel() {
    Swal.fire({
      title: 'Você deseja cancelar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim, desejo!'
    }).then((result) => {
      if (result.value) {
        this.loading = true
        this.changed = false
        this.getDeliveryCondig()
      }
    })
  }

  saveError() {
    Swal.fire("Ops!", "Ocorreu um erro ao tentar salvar.", "error")
  }

  saveComplete() {
    Swal.fire("Salvo!", "As configuraçõs de frete e entrega foram salvas", "success")
  }

  saving() {
    Swal.fire({
      title: "Salvando...",
      icon: "info",
      showCancelButton: false,
      allowOutsideClick: false,
      showConfirmButton: false
    });
  }

  onSubmit() {
    let data = {
      entrega_local: this.status.value ? 'S' : 'N',
      taxa_entrega_local: this.select_drivethru_type.value == '1' ? null : this.taxa_entrega_local.value,
      entrega_local_gratis: this.ck_free.value ? this.entrega_local_gratis.value : null,
      holidays: []
    }

    let holidays = []
    for(let i in this.holidays.controls) {
      let fGroup = <FormGroup>this.holidays.controls[i];

      let dia = <FormControl>fGroup.controls.dia;

      if (dia.value != null && dia.value != '') {
        let tdia = ''
        if (dia.value != null && typeof(dia.value) === 'object') {
          tdia = dia.value.format('YYYY-MM-DD');
        } else {
          tdia = dia.value
        }

        let tipo = <FormControl>fGroup.controls.tipo;

        holidays.push([tdia, tipo.value])
      }
    }
    data['holidays'] = holidays


    let agendamento = {
      drivethru: this.ck_drivethru.value ? 'S' : 'N',
      intervalo_entrega_drivethru: this.intervalo_entrega_drivethru.value,
      tempo_liberacao_drivethru: this.tempo_liberacao_drivethru.value,
      num_entrega_drivethru: this.num_entrega_drivethru.value
    }

    let scheduling = []
    for(let i in this.scheduling.controls) {
      let fGroup = <FormGroup>this.scheduling.controls[i];

      let diasemana = <FormControl>fGroup.controls.diasemana;
      let hora_inicio = <FormControl>fGroup.controls.hora_inicio;
      let hora_fim = <FormControl>fGroup.controls.hora_fim;

      if (diasemana.value != null && diasemana.value != '' && hora_inicio.value != null && hora_inicio.value != '' && hora_fim.value != null && hora_fim.value != '') {
          scheduling.push([diasemana.value, hora_inicio.value, hora_fim.value])
      }
    }

    agendamento['scheduling'] = scheduling
    data['agendamento'] = agendamento

    this.saving()

    this.storeService.storeDriveThru(data).subscribe(res => {
      if (res['success']) {
        //
        this.resDriveThru(res)
        //
        this.changed = false
        //
        this.saveComplete()
      } else {
        this.saveError()
      }
    })

    return null
  }

}
